import { render, staticRenderFns } from "./upload-modal.vue?vue&type=template&id=5deed27c"
import script from "./upload-modal.vue?vue&type=script&lang=js"
export * from "./upload-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5deed27c')) {
      api.createRecord('5deed27c', component.options)
    } else {
      api.reload('5deed27c', component.options)
    }
    module.hot.accept("./upload-modal.vue?vue&type=template&id=5deed27c", function () {
      api.rerender('5deed27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/upload-modal.vue"
export default component.exports